<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- 页头 -->
							<div class="page_header">
								Search Training Records
							</div>
							<div class="page_main">
								<el-form :model="query" label-position="top" class="search-form">
								    <div class="form-grid">
								        <!-- Left -->
								        <div class="form-col">
								            <el-form-item label="Training Item Type">
								                <el-select v-model="query.leixing" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="General Training Item" :value="1" />
								                    <el-option label="Document" :value="2" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Item ID">
								                <el-input v-model="query.item_name" placeholder="Please enter" clearable />
								            </el-form-item>
								
								            <el-form-item label="User">
								                <div class="input-btn-group">
								                    <el-select v-model="query.uid" filterable placeholder="Please select" clearable style="width: 100%;">
								                        <el-option
								                            v-for="value in userList"
								                            :key="value.id"
								                            :label="value.username"
								                            :value="value.id">
								                        </el-option>
								                    </el-select>
								                </div>
								            </el-form-item>
								
								            <!-- <el-form-item label="Company">
								                <div class="input-btn-group">
								                    <el-select
								                        v-model="query.company_id"
								                        placeholder="Please select"
								                        class="full-width"
								                        @change="getDepartment(query.company_id)"
								                        clearable>
								                        <el-option
								                            v-for="value in companyList"
								                            :key="value.id"
								                            :label="value.company_name"
								                            :value="value.id">
								                        </el-option>
								                    </el-select>
								                </div>
								            </el-form-item> -->
								
								            <el-form-item label="Department">
								                <div class="input-btn-group">
								                    <el-select
								                        v-model="query.departments_id"
								                        placeholder="Please select"
								                        class="full-width"
								                        clearable>
								                        <el-option
								                            v-for="value in departmentsList"
								                            :key="value.id"
								                            :label="value.departments_name"
								                            :value="value.id">
								                        </el-option>
								                    </el-select>
								                </div>
								            </el-form-item>
								
								            <el-form-item label="Training Purpose">
								                <el-select v-model="query.purpose" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Initial Training" :value="1" />
								                    <el-option label="Retraining" :value="2" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Has Supervisor">
								                <el-select v-model="query.is_supervise" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Yes" :value="1" />
								                    <el-option label="No" :value="2" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Supervisor">
								                <div class="input-btn-group">
								                    <el-select v-model="query.supervise_uid" filterable placeholder="Please select" clearable style="width:100%;">
								                        <el-option
								                            v-for="value in userList"
								                            :key="value.id"
								                            :label="value.username"
								                            :value="value.id">
								                        </el-option>
								                    </el-select>
								                </div>
								            </el-form-item>
								
								            <el-form-item label="Training Type">
								                <el-select v-model="query.train_leixing_id" class="full-width" placeholder="Please select" clearable>
								                    <el-option
								                        v-for="(value,index) in trainLeixingList"
								                        :key="index"
								                        :label="value.title"
								                        :value="value.id" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Requirement Met?">
								                <el-select v-model="query.is_meet" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Yes" :value="1" />
								                    <el-option label="No" :value="2" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Assigned User">
								                <el-select v-model="query.is_assigned" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Yes" :value="1" />
								                    <el-option label="No" :value="2" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Training Overdue?">
								                <el-select v-model="query.is_expire" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Yes" :value="1" />
								                    <el-option label="No" :value="2" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Training Status">
								                <el-select v-model="query.status" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Training Incomplete" :value="1" />
								                    <el-option label="Certification Pending" :value="2" />
								                    <el-option label="Completed" :value="3" />
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Training Sign-off Status">
								                <el-select v-model="query.training_signoff_completed" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Incomplete" :value="1" />
								                    <el-option label="Completed" :value="2" />
								                </el-select>
								            </el-form-item>
								
								        </div>
								
								        <!-- Right -->
								        <div class="form-col">
								
								            <el-form-item label="Created Date">
								                <el-date-picker
								                    v-model="time"
								                    type="datetimerange"
								                    @change="getTime"
								                    range-separator="to"
								                    start-placeholder="Start Date"
								                    end-placeholder="End Date"
								                    class="full-width"
								                    :default-time="['00:00:00','23:59:59']">
								                </el-date-picker>
								            </el-form-item>
								
								            <el-form-item label="Training Due Date">
								                <el-date-picker
								                    v-model="time1"
								                    type="datetimerange"
								                    @change="getTime1"
								                    range-separator="to"
								                    start-placeholder="Start Date"
								                    end-placeholder="End Date"
								                    class="full-width"
								                    :default-time="['00:00:00','23:59:59']">
								                </el-date-picker>
								            </el-form-item>
								
								            <el-form-item label="Training Completion Date">
								                <el-date-picker
								                    v-model="time2"
								                    type="datetimerange"
								                    @change="getTime2"
								                    range-separator="to"
								                    start-placeholder="Start Date"
								                    end-placeholder="End Date"
								                    class="full-width"
								                    :default-time="['00:00:00','23:59:59']">
								                </el-date-picker>
								            </el-form-item>
								
								            <el-form-item label="Certification Due Date">
								                <el-date-picker
								                    v-model="time4"
								                    type="datetimerange"
								                    @change="getTime4"
								                    range-separator="to"
								                    start-placeholder="Start Date"
								                    end-placeholder="End Date"
								                    class="full-width"
								                    :default-time="['00:00:00','23:59:59']">
								                </el-date-picker>
								            </el-form-item>
								
								            <el-form-item label="Certification Completion Date">
								                <el-date-picker
								                    v-model="time5"
								                    type="datetimerange"
								                    @change="getTime5"
								                    range-separator="to"
								                    start-placeholder="Start Date"
								                    end-placeholder="End Date"
								                    class="full-width"
								                    :default-time="['00:00:00','23:59:59']">
								                </el-date-picker>
								            </el-form-item>
								
								            <el-form-item label="Certification Required?">
								                <el-select v-model="query.is_certification" placeholder="Please select" class="full-width" clearable>
								                    <el-option label="Yes" :value="1"></el-option>
								                    <el-option label="No" :value="2"></el-option>
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Certification Overdue?">
								                <el-select v-model="query.is_certification_expire" placeholder="Please select" class="full-width" clearable>
								                    <el-option label="No" :value="1"></el-option>
								                    <el-option label="Yes" :value="2"></el-option>
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Certification Completed">
								                <el-select v-model="query.certification_completed" placeholder="Please select" class="full-width" clearable>
								                    <el-option label="Yes" :value="1"></el-option>
								                    <el-option label="No" :value="2"></el-option>
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Certification Sign-off User">
								                <div class="input-btn-group">
								                    <el-select v-model="query.certification_signoff_user" filterable placeholder="Please select" clearable style="width:100%;">
								                        <el-option
								                            v-for="value in userList"
								                            :key="value.id"
								                            :label="value.username"
								                            :value="value.id">
								                        </el-option>
								                    </el-select>
								                </div>
								            </el-form-item>
								
								            <el-form-item label="Certification Evidence Available?">
								                <el-select v-model="query.certification_files" placeholder="Please select" class="full-width" clearable>
								                    <el-option label="Yes" :value="1"></el-option>
								                    <el-option label="No" :value="2"></el-option>
								                </el-select>
								            </el-form-item>
								
								            <el-form-item label="Training Sign-off User">
								                <div class="input-btn-group">
								                    <el-select v-model="query.training_signoff_user" filterable placeholder="Please select" clearable style="width:100%;">
								                        <el-option
								                            v-for="value in userList"
								                            :key="value.id"
								                            :label="value.username"
								                            :value="value.id">
								                        </el-option>
								                    </el-select>
								                </div>
								            </el-form-item>
								
								            <el-form-item label="Training Evidence Available?">
								                <el-select v-model="query.training_files" class="full-width" placeholder="Please select" clearable>
								                    <el-option label="Yes" :value="1" />
								                    <el-option label="No" :value="2" />
								                </el-select>
								            </el-form-item>
								
								        </div>
								    </div>
								
								    <div class="search-btn-wrap">
								        <el-button type="primary" @click="handleSearch">
								            Search
								        </el-button>
								    </div>
								</el-form>
								<!--Table-->
								<div class="file-panel">
								    <div class="panel-header">
								        <div></div>
								        <el-input v-model="keyword" placeholder="Search" clearable class="search-input">
								            <i slot="prefix" class="el-input__icon el-icon-search"></i>
								        </el-input>
								    </div>
								
								    <el-table
								        v-loading="tableloading"
								        :data="trainTableData"
								        border
								        class="file-table"
								        header-cell-class-name="table-header-cell">
								
								        <el-table-column
								            prop="item_name"
								            label="Item ID"
								            width="150"
								            sortable="custom"
								            show-overflow-tooltip
								        />
								
								        <el-table-column
								            prop="username"
								            label="User"
								            width="150"
								            sortable="custom"
								            show-overflow-tooltip
								        />
								
								        <el-table-column
								            prop=""
								            label="Purpose"
								            width="120"
								            sortable="custom">
								
								            <template slot-scope="scope">
								                {{ scope.row.purpose == 1 ? 'Initial Training' : 'Retraining' }}
								            </template>
								
								        </el-table-column>
								
								        <el-table-column
								            prop=""
								            label="Training Status"
								            width="170"
								            sortable="custom">
								
								            <template slot-scope="scope">
								                <div v-if="scope.row.status == 1">Training Incomplete</div>
								                <div v-if="scope.row.status == 2">Certification Pending</div>
								                <div v-if="scope.row.status == 3">Completed</div>
								            </template>
								
								        </el-table-column>
								
								        <el-table-column
								            prop="train_leixing_name"
								            label="Training Type"
								            width="140"
								            sortable="custom"
								            show-overflow-tooltip>
								        </el-table-column>
								
								        <el-table-column
								            prop=""
								            label="Training Due Date"
											width="180"
								            sortable="custom">
								
								            <template slot-scope="scope">
								                {{ scope.row.end_time }}
								            </template>
								
								        </el-table-column>
								
								        <el-table-column
								            prop=""
								            label="Training Completion Date"
								            width="230"
								            sortable="custom">
								
								            <template slot-scope="scope">
								                {{ scope.row.training_completed_date }}
								            </template>
								
								        </el-table-column>
								
								        <el-table-column
								            prop=""
								            label="Certification Required?"
								            width="210"
								            sortable="custom">
								
								            <template slot-scope="scope">
								                {{ scope.row.is_certification == 1 ? 'Yes' : 'No' }}
								            </template>
								
								        </el-table-column>
								
								        <el-table-column
								            prop=""
								            label="Certification Due Date"
								            sortable="custom"
											width="210"
								            align="center">
								
								            <template slot-scope="scope">
								                {{ scope.row.certification_end_time }}
								            </template>
								
								        </el-table-column>
								
								        <el-table-column
								            prop=""
								            label="Certification Completion Date"
								            width="260"
								            sortable="custom"
								            align="center">
								
								            <template slot-scope="scope">
								                {{ scope.row.certification_completed_date }}
								            </template>
								
								        </el-table-column>
								
								        <el-table-column
								            label="Action"
								            width="80"
								            fixed="right"
								            align="center">
								
								            <template slot-scope="scope">
								                <el-link
								                    type="primary"
								                    size="mini"
								                    @click="handleInfo(scope.row)">
								                    Details
								                </el-link>
								            </template>
								
								        </el-table-column>
								
								    </el-table>
								
								    <div class="pagination">
								        <el-pagination
								            @size-change="handleSizeChange"
								            @current-change="handlePageChange"
								            :current-page="query.page"
								            :page-sizes="[5, 10, 20, 50]"
								            :page-size="query.page_size"
								            layout="total, sizes, prev, pager, next"
								            :total="pageTotal">
								        </el-pagination>
								    </div>
								</div>
								<!--Table-->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!-- loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
	</div>
</template>

<script>
	import {
		trainList
	} from "@/api/trainManage/trainSearch/index";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import UserSelect from "@/component/user-select.vue";
	import {
		usersList
	} from "@/api/system/user";
	// import {
	// 	companyList
	// } from "@/api/system/company";
	import {
		departmentsList
	} from "@/api/system/department";
	import {
		trainLeixingList
	} from '@/api/trainManage/configTrain/trainType/index';
	import moment from "moment";
	moment.locale("zh-cn");
	export
	default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				tableloading: true,
				keyword: "",
				query: {
					leixing: "",
					item_name: "",
					uid: "",
					// company_id: "",
					departments_id: "",
					purpose: "",
					is_supervise: "",
					supervise_uid: "",
					train_leixing_id: "",
					is_meet: "",
					is_assigned: "",
					is_expire: "",
					training_signoff_completed: "",
					is_certification: "",
					is_certification_expire: "",
					certification_completed: "",
					certification_signoff_user: "",
					certification_files: "",
					training_signoff_user: "",
					training_files: "",
					date_line1: '',
					date_line2: '',
					end_time1: '',
					end_time2: '',
					training_completed_date1: '',
					training_completed_date2: '',
					certification_end_time1: '',
					certification_end_time2: '',
					certification_completed_date1: '',
					certification_completed_date2: '',
					page: 1,
					page_size: 10,
					status: ''
				},
				time: "",
				time1: "",
				time2: "",
				time4: "",
				time5: "",
				userName: "",
				selectedId: null,
				userList: [],
				tableData: [],
				// companyList: [],
				departmentsList: [],
				pageTotal: 0,
				trainLeixingList: []
			};
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			that.getTableData();
			that.getUserList();
			//请求培训类型
			trainLeixingList({
				title: ''
			}).then(res => {
				if (res.code == 200) {
					that.trainLeixingList = res.data;
				}
			});
			that.getDepartment();
			//请求公司列表
			// companyList({
			// 	page: 1,
			// 	page_size: 9999,
			// 	status: 1,
			// 	company_name: "",
			// 	company_userid: "",
			// 	manage_userid: "",
			// }).then((res2) => {
			// 	if (res2.code == 200) {
			// 		that.companyList = res2.data.data;
			// 	}
			// });
		},
		computed: {
			trainTableData() {
				return this.filterTableData(this.tableData, this.keyword);
			},
		},
		methods: {
			//时间戳转换
			initTime(value) {
				if (value) {
					return moment(value * 1000).format('YYYY-MM-DD');
				}
			},
			filterTableData(source, keyword) {
				if (!keyword || !keyword.trim()) return source;
				const lowerKeyword = keyword.toLowerCase().trim();
				return source.filter((item) => {
					const text = this.flattenValues(item).toLowerCase();
					return text.includes(lowerKeyword);
				});
			},
			flattenValues(data) {
				if (data === null || data === undefined) return "";
				if (Array.isArray(data)) {
					return data.map((item) => this.flattenValues(item)).join(" ");
				}
				if (typeof data === "object") {
					return Object.values(data).map((val) => this.flattenValues(val)).join(" ");
				}
				return String(data);
			},
			getUserList() {
				let that = this;
				usersList({
					status: 1,
					page: 1,
					page_size: 999999
				}).then((res) => {
					if (res.code == 200) {
						that.userList = res.data.data;
						that.isLoading = false;
					}
				});
			},
			//请求部门列表
			getDepartment(val) {
				let that = this;
				that.query.departments_id = "";
				that.departmentsList = [];
				that.$toast.loading({
					duration: 0,
					forbidClick: true
				});
				departmentsList({
					page: 1,
					page_size: 9999,
					status: 1,
					departments_name: "",
					departments_userid: "",
				}).then((res2) => {
					that.$toast.clear();
					that.departmentsList = res2.data.data;
					if (val) {
						that.query.departments_id = Number(val);
					}
				});
			},
			//时间格式化
			dateFormat: function(row, column) {
				let that = this;
				var date = row[column.property];
				if (date == undefined || date == 0) {
					return "/";
				}
				return moment(date * 1000).format("YYYY-MM-DD");
			},
			//创建日期
			getTime(date) {
				let that = this;
				if (date) {
					that.query.date_line1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.date_line2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.date_line1 = "";
					that.query.date_line2 = "";
				}
			},
			//所需培训日期
			getTime1(date) {
				let that = this;
				if (date) {
					that.query.end_time1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.end_time2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.end_time1 = "";
					that.query.end_time2 = "";
				}
			},
			//培训完成日期
			getTime2(date) {
				let that = this;
				if (date) {
					that.query.training_completed_date1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.training_completed_date2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.training_completed_date1 = "";
					that.query.training_completed_date2 = "";
				}
			},
			//所需认证截止日期
			getTime4(date) {
				let that = this;
				if (date) {
					that.query.certification_end_time1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.certification_end_time2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.certification_end_time1 = "";
					that.query.certification_end_time2 = "";
				}
			},
			//认证完成日期
			getTime5(date) {
				let that = this;
				if (date) {
					that.query.certification_completed_date1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.certification_completed_date2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.certification_completed_date1 = "";
					that.query.certification_completed_date2 = "";
				}
			},
			getTableData() {
				let that = this;
				that.tableloading = true;
				trainList(that.query).then(res => {
					that.tableloading = false;
					that.tableData = res.data.data;
					that.pageTotal = res.data.total;
					// console.log(that.tableData);
				});
			},
			handleSearch() {
				let that = this;
				that.query.page = 1;
				that.getTableData();
			},
			//清空搜索项
			clearSearch() {
				let that = this;
				that.query = {
					leixing: "",
					item_name: "",
					uid: "",
					// company_id: "",
					departments_id: "",
					purpose: "",
					is_supervise: "",
					supervise_uid: "",
					train_leixing_id: "",
					is_meet: "",
					is_assigned: "",
					is_expire: "",
					training_signoff_completed: "",
					is_certification: "",
					is_certification_expire: "",
					certification_completed: "",
					certification_signoff_user: "",
					certification_files: "",
					training_signoff_user: "",
					training_files: "",
					date_line1: '',
					date_line2: '',
					end_time1: '',
					end_time2: '',
					training_completed_date1: '',
					training_completed_date2: '',
					certification_end_time1: '',
					certification_end_time2: '',
					certification_completed_date1: '',
					certification_completed_date2: '',
					page: 1,
					page_size: 10,
					status: ''
				};
				that.time = null;
				that.time1 = null;
				that.time2 = null;
				that.time4 = null;
				that.time5 = null;
				that.getTableData();
			},
			//条数选择
			handleSizeChange(value) {
				let that = this;
				that.query.page_size = value;
				that.getTableData();
			},
			//页数跳转
			handlePageChange(value) {
				let that = this;
				that.query.page = value;
				that.getTableData();
			},
			handleConfirm({
				id,
				user
			}) {
				let that = this;
				that.selectedId = id || null;
				that.userName = user ? user.username : "";
			},
			handleInfo(value) {
				let that = this;
				const routeData = that.$router.resolve({
					path: '/TrainControl/record-detail',
					query: {
						id: value.id
					}
				});
				window.open(routeData.href, "_blank");
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 24px;
		align-items: start;
	}

	.form-grid .el-form-item {
		margin-bottom: 0;
	}

	.full-width {
		width: 100%;
	}

	.input-btn-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.input-btn-group .el-input {
		flex: 1;
	}

	.search-btn-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 20px 0 16px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.pagination {
		margin: 10px 0;
		text-align: right;
	}

	::v-deep .el-form-item__label {
		font-size: 16px;
		color: #222;
		font-weight: 700;
		padding-bottom: 8px;
		position: relative;
	}

	::v-deep .el-input__inner,
	::v-deep .el-textarea__inner {
		border-radius: 4px;
	}

	@media (max-width: 1200px) {
		.form-grid {
			grid-template-columns: 1fr;
		}
	}

	::v-deep .el-button {
		border-radius: 6px;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}

	::v-deep .form-grid .el-form-item__label {
		padding-bottom: 0;
	}
</style>